<app-breadcrumb [title]="'Olvido de Contraseña'" [breadcrumb]="'Olvido de Contraseña'"></app-breadcrumb>
<!-- section start -->
<section class="pwd-page">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 offset-lg-3">
                <h2>Restaurar mi contraseña</h2>
                <form class="theme-form">
                    <div class="row">
                        <div class="col-md-12">
                            <input name="email" [(ngModel)]="person.email" type="email" class="form-control" id="email" placeholder="Ingresa tu correo electrónico" required="">
                        </div>
                    </div>
                    <button class="btn btn-solid" (click)="onSubmit()">Enviar</button>
                </form>
            </div>
        </div>
    </div>
</section>
<!--Section ends-->